import React from 'react';
import { MeetingDashboardKPIs } from './types';

interface Props {
  kpis: MeetingDashboardKPIs | null;
}

export const MeetingsMetricsCards: React.FC<Props> = ({ kpis }) => {
  if (!kpis) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Total Meetings</span>
        <span className="stat-value" style={{ color: '#0f172a' }}>{kpis.total_meetings}</span>
        <span className="stat-sub">{kpis.scheduled_meetings} Scheduled / In Preparation</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Completed Meetings</span>
        <span className="stat-value" style={{ color: '#059669' }}>{kpis.completed_meetings}</span>
        <span className="stat-sub">{kpis.in_progress_meetings} In Progress Session</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Management Reviews</span>
        <span className="stat-value" style={{ color: '#7c3aed' }}>{kpis.management_reviews_count}</span>
        <span className="stat-sub">EASA / ISO Annual Review</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Committee Decisions</span>
        <span className="stat-value" style={{ color: '#0f172a' }}>{kpis.total_decisions_count}</span>
        <span className="stat-sub">Formal Committee Directives</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Linked Actions Bridge</span>
        <span className="stat-value" style={{ color: kpis.open_meeting_actions_count > 0 ? '#d97706' : '#059669' }}>
          {kpis.open_meeting_actions_count} / {kpis.linked_central_actions_count}
        </span>
        <span className="stat-sub">Open / Total Linked Actions</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Attendance & Quorum</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>%{kpis.average_attendance_rate}</span>
        <span className="stat-sub">Quorum Achievement: %{kpis.quorum_achievement_rate}</span>
      </div>
    </div>
  );
};
